import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { ServiceBase } from './servicebase.service';

@Injectable({
  providedIn: 'root'
})
export class FieldDivisionGroupsService extends ServiceBase {

  public addFieldDivisionGroup(fdGroup: ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups): Observable<ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups> {
    return this.http.post<ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups>(`${this.apiRoot}/api/FieldDivisionGroup/AddOrUpdateFieldDivisionGroup`, fdGroup, this.httpOptions).pipe(catchError(this.swallowError<any>('addFieldDivisionGroup', 'defaultMsg', null, null))); 
  }

  public updateFieldDivisionGroup(fdGroup: ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups): Observable<ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups> {
    return this.http.post<ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups>(`${this.apiRoot}/api/FieldDivisionGroup/AddOrUpdateFieldDivisionGroup`, fdGroup, this.httpOptions).pipe(catchError(this.swallowError<any>('updateFieldDivisionGroup', 'defaultMsg', null, null))); 
  }

  public getAllFieldDivisions(): Observable<ServerModels.ENESS_REF_FieldDivisions[]> {
    return this.http.get<ServerModels.ENESS_REF_FieldDivisions[]>(`${this.apiRoot}/api/FieldDivisionGroup/GetAllFieldDivisions`, this.httpOptions).pipe(catchError(this.swallowError<any>('getAllFieldDivisions', 'defaultMsg', null, null))); 
  }

  public getFieldDivisionGroups(): Observable<ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups[]> {
    return this.http.get<ServerModels.ENESS_REF_IntelligenceReportATFReferralGroups[]>(`${this.apiRoot}/api/FieldDivisionGroup/GetAllFieldDivisionGroups`, this.httpOptions).pipe(catchError(this.swallowError<any>('getFieldDivisionGroups', 'defaultMsg', null, null))); 
  }


}
